import React from 'react';

import Dashboard from '../dashboard/Dashboard';

function ReportSample(props) {
  return (
    <Dashboard {...props} />
  );
}

export default ReportSample;
